import { Thrico, ThricoClient } from "./core/thrico";

// Attach helper constructor and exports onto the singleton itself
(Thrico as any).ThricoClient = ThricoClient;
(Thrico as any).Thrico = Thrico;

if (typeof window !== "undefined") {
  (window as any).Thrico = Thrico;
  (window as any).ThricoClient = ThricoClient;
}

export = Thrico;
